// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Ty8p","cell":"ColumnAccessor_cell__1ul34","firstCellAccent":"ColumnAccessor_firstCellAccent__2lSet"};